import React, {useMemo, useState} from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import {useStore} from 'effector-react';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as yup from 'yup';

import {purchaseMarkingCodes} from 'api/billing';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Input} from 'components/ui-kit/Input';
import {Modal} from 'components/ui-kit/Modal';
import {Checkbox} from 'components/ui-kit/Сheckbox';

import {profile$} from 'models/auth';

import {ModalContainerCentered, LoadingSubtitle, Loader} from './styled';

export const LoaderDoted = () => {
    const {t} = useTranslation();
    return (
        <ModalContainerCentered>
            <LoadingSubtitle>
                {t('pages.profile.billing.invoiceGenerating.loadingSubtitle')}
            </LoadingSubtitle>
            <Loader>
                <img src={'/extra/circle.webp'} alt="Loader" />
            </Loader>
        </ModalContainerCentered>
    );
};
